const AboutPage = () => {

  return (
      <div>
          <h1>AboutPage  Page </h1>
      </div>
  )
}

export default AboutPage;